export const SHOW_GLOBAL_SEARCH_PARAM_KEY = "showGlobalSearch"
export const SHOW_GLOBAL_SEARCH_PARAM_VALUES = {
  "OPEN": "1",
  "CLOSE": undefined
}
